import $ from 'jquery'
import Isotope from 'isotope-layout'
var iso = ''
var isoMobile = ''
var projectType = ''
var location = ''
var date = ''

const parent = $('.js-index-container')
if (parent.length) {
    iso = new Isotope('.js-index-container', {
        itemSelector: '.js-index-project',
        layoutMode: 'masonry'
    })
    isoMobile = new Isotope('.js-index-mobile-container', {
        itemSelector: '.js-index-project',
        layoutMode: 'masonry'
    })
}

$('.js-search-index-button').click(function() {
    $('.js-index-search').fadeToggle()
})

$(document).keydown(function(event) {
    if (event.key === "Escape") {
        $('.js-index-search').fadeOut();
    }
});

$('#project_type').on('change', function () {
    projectType = $(this).val() * 1
})

$('#location').on('change', function () {
    location = $(this).val() * 1
})

$('#date').on('change', function () {
    date = $(this).val() * 1
})

$('.js-search').click(function() {
    iso.arrange({
        filter: function () {
            const post = $(this)

            let projectTypesMatched = true
            let projectTypes = post.attr('data-project-types')
            projectTypes = projectTypes.includes(',') ? projectTypes.split(',') : [projectTypes]
            projectTypes = projectTypes.map(Number)
            if (projectType) {
                projectTypesMatched = projectTypes.includes(projectType)
            }

            let locationsMatched = true
            let locations = post.attr('data-locations')
            locations = locations.includes(',') ? locations.split(',') : [locations]
            locations = locations.map(Number)
            if (location) {
                locationsMatched = locations.includes(location)
            }

            let datesMatched = true
            let dates = post.attr('data-dates')
            dates = dates.includes(',') ? dates.split(',') : [dates]
            dates = dates.map(Number)
            if (date) {
                datesMatched = dates.includes(date)
            }

            return (
                projectTypesMatched &&
                locationsMatched &&
                datesMatched
            )
        },
    })

    isoMobile.arrange({
        filter: function () {
            const post = $(this)

            let projectTypesMatched = true
            let projectTypes = post.attr('data-project-types')
            projectTypes = projectTypes.includes(',') ? projectTypes.split(',') : [projectTypes]
            projectTypes = projectTypes.map(Number)
            if (projectType) {
                projectTypesMatched = projectTypes.includes(projectType)
            }

            let locationsMatched = true
            let locations = post.attr('data-locations')
            locations = locations.includes(',') ? locations.split(',') : [locations]
            locations = locations.map(Number)
            if (location) {
                locationsMatched = locations.includes(location)
            }

            let datesMatched = true
            let dates = post.attr('data-dates')
            dates = dates.includes(',') ? dates.split(',') : [dates]
            dates = dates.map(Number)
            if (date) {
                datesMatched = dates.includes(date)
            }

            return (
                projectTypesMatched &&
                locationsMatched &&
                datesMatched
            )
        },
    })

    $('.js-index-search').fadeOut()
});

$('.js-index-project').hover(
    function() {
      $(this).find('.js-hover').fadeIn();
      $(this).addClass('hover-active')
    },
    function() {
      $(this).find('.js-hover').fadeOut();
        $(this).removeClass('hover-active')
    }
);

$('.js-have-page').click(function() {
    window.location = $(this).data('href');
});

$('.js-reset-filters').click(function() {
    $('.vn-select').each(function() {
        $(this).val('0');
        $('#project_type').trigger('change')
        $('#location').trigger('change')
        $('#date').trigger('change')
        $('.js-search').trigger('click')
    });
});
